import Component from 'vue-class-component'
import './setup-filters'
import './directives/autobind'
(window as any).NODE_ENV = process.env.NODE_ENV

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate',
  'beforeMount',
  'beforeUpdate',
  'beforeDestroy'
])
